import React, { useLayoutEffect, useRef, useState } from 'react';
import Lottie from 'lottie-react';
import animationData from '../../assets/animations/product-design-dots.json';

const LOTTIE_NATIVE = 150;
const COVER_BLEED = 1.25;

const ContactDotBackground: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [coverSize, setCoverSize] = useState(0);

  useLayoutEffect(() => {
    const element = containerRef.current;
    if (!element) {
      return undefined;
    }

    const updateSize = () => {
      const { width, height } = element.getBoundingClientRect();
      if (width <= 0 || height <= 0) {
        return;
      }

      const scale = Math.max(width / LOTTIE_NATIVE, height / LOTTIE_NATIVE) * COVER_BLEED;
      setCoverSize(Math.ceil(LOTTIE_NATIVE * scale));
    };

    updateSize();

    const observer = new ResizeObserver(updateSize);
    observer.observe(element);
    window.addEventListener('resize', updateSize);

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', updateSize);
    };
  }, []);

  return (
    <div className="contact-dot-bg" ref={containerRef} aria-hidden="true">
      <div className="contact-dot-bg-base" />
      <div className="contact-dot-stage">
        {coverSize > 0 && (
          <Lottie
            animationData={animationData}
            loop
            autoplay
            className="contact-dot-lottie"
            style={{
              width: coverSize,
              height: coverSize,
              transform: 'translate(-50%, -50%)',
            }}
            rendererSettings={{ preserveAspectRatio: 'xMidYMid slice' }}
          />
        )}
      </div>
    </div>
  );
};

export default ContactDotBackground;
